import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import style from './index.scss';

const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';

/* DateRange Picker
 *
 * Take note: the values returned when selecting dates within this picker is in moment object
 * meaning, you can take advantage of moment's functions out of the box
 *
 */

class RangeDatePicker extends React.Component {
  state = {};

  onRangeChange = (dates) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(dates);
    }
  };

  render() {
    const { defaultDates, size, disabledDate } = this.props;
    return (
      <div className={style.dateRangePickerContainer}>
        <RangePicker
          value={defaultDates}
          separator="~"
          onChange={this.onRangeChange}
          format={dateFormat}
          allowClear={false}
          size={size ? size : 'medium'}
          disabledDate={disabledDate}
        />
      </div>
    );
  }
}

RangeDatePicker.propTypes = {
  onChange: PropTypes.func,
  defaultDates: PropTypes.array,
  size: PropTypes.string,
  disabledDate: PropTypes.func
};

export default RangeDatePicker;
